export default class DPProOnlyOption {
	constructor(config) {
		if (config.dpDebugEn) console.log('DPProOnlyOption');
		this.config = config;
		$('.dpit-pro-only').closest('tr').find('th').addClass('dpit-pro-only');

		$('.dpit-pro-only, .acf-field-group[data-name="intro_url_variables"] .acf-fields').on('click', (event) => {
			if ($(event.target).closest('.dpit-info-icon').length || $(event.target).closest('.tippy-content').length) return true;
			event.preventDefault();
			event.stopPropagation();
			if (this.config.proFeaturesLink) {
				if (confirm(this.config.i18n.feature_pro_only)) {
					window.open(this.config.proFeaturesLink, '_blank');
				}
			}
			return false;
		});
		//.acf-field-group[data-name="intro_design"] .acf-fields,
	}
}
